import { render, staticRenderFns } from "./MoreLive.vue?vue&type=template&id=84ae68b2&scoped=true&"
import script from "./MoreLive.vue?vue&type=script&lang=js&"
export * from "./MoreLive.vue?vue&type=script&lang=js&"
import style0 from "./MoreLive.vue?vue&type=style&index=0&id=84ae68b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ae68b2",
  null
  
)

export default component.exports